// extracted by mini-css-extract-plugin
export default {"container":"RealPlayView_container__Z+xBZ","left":"RealPlayView_left__OiBdu","right":"RealPlayView_right__MBLdb"};